var map = {
	"./Draugiem": "A1dM",
	"./Draugiem.jsx": "A1dM",
	"./Facebook": "jX/i",
	"./Facebook.jsx": "jX/i",
	"./Instagram": "ETL1",
	"./Instagram.jsx": "ETL1",
	"./Twitter": "kcGB",
	"./Twitter.jsx": "kcGB",
	"./Youtube": "dAZM",
	"./Youtube.jsx": "dAZM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vQIM";


//////////////////
// WEBPACK FOOTER
// ./src/core/icons/components/social ^\.\/.*$
// module id = vQIM
// module chunks = 35